const getters = {
  serverFilters: state => state.company_filters,
  servers: state => state.servers,
}

export default getters;
